import { InvoiceRow } from '@blisspointmedia/bpm-types/dist/BillingAutomation';
import { invoiceMonthKey } from '@Pages/BillingAutomation/billing-utils';
import { APPROVED_RELATIONSHIPS, FinanceRow } from './finance-constants';

export const yesNo = (value: boolean): 'Yes' | 'No' => (value ? 'Yes' : 'No');

export const isApprovedInvoice = (cid: string, row: InvoiceRow): boolean =>
  APPROVED_RELATIONSHIPS[cid]?.includes(row.salesforceRelationshipName ?? '') ?? false;

// Keeps only the approved relationships for the CID and adds the columns the table needs.
export const toFinanceRows = (cid: string, invoices: InvoiceRow[]): FinanceRow[] =>
  invoices
    .filter(row => isApprovedInvoice(cid, row))
    .map(row => ({
      ...row,
      cid,
      month: invoiceMonthKey(row),
      signedOff: yesNo(Boolean(row.signedOffBy)),
      toolUsed: '',
      toolSpend: ''
    }));
